import { ArrowLeft } from "lucide-react";
import { Link } from "react-router-dom";

export const Accessibility = () => (
  <div className="min-h-screen bg-gradient-to-b from-[#1a1a1a] to-black text-white">
    <div className="container mx-auto px-4 py-12">
      <Link
        to="/"
        className="inline-flex items-center text-gray-400 hover:text-white mb-8"
      >
        <ArrowLeft className="mr-2" /> Back to Home
      </Link>

      <div className="glass-card p-8 max-w-4xl mx-auto">
        <h1 className="text-3xl font-bold mb-4">Accessibility Statement</h1>
        <p className="text-gray-400 mb-8">Effective Date: February 15, 2026</p>

        <div className="space-y-8 text-gray-300">
          <section>
            <h2 className="text-xl font-semibold mb-4 text-white">
              Our Commitment
            </h2>
            <p>
              Agent FOMO is committed to ensuring digital accessibility for
              people of all abilities. We strive to continually improve the user
              experience for everyone and apply relevant accessibility standards
              to guarantee that our Service is inclusive and usable by the
              widest possible audience.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-4 text-white">
              Conformance Standards
            </h2>
            <p>
              We aim to conform to the Web Content Accessibility Guidelines
              (WCAG) 2.1 at Level AA. These guidelines define requirements for
              designers and developers to improve accessibility for people with
              disabilities, including visual, auditory, physical, speech,
              cognitive, language, learning, and neurological disabilities.
              Compliance with these guidelines also makes web content more
              usable for all users.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-4 text-white">
              Measures Taken
            </h2>
            <p className="mb-4">
              Agent FOMO takes the following measures to ensure accessibility of
              our platform:
            </p>
            <ul className="list-disc pl-6 space-y-2">
              <li>
                Semantic HTML structure to support assistive technologies and
                screen readers.
              </li>
              <li>
                Sufficient color contrast ratios throughout the user interface
                to ensure readability.
              </li>
              <li>
                Keyboard navigation support for all interactive elements on the
                website.
              </li>
              <li>
                Descriptive alternative text for all meaningful images and
                visual content.
              </li>
              <li>
                Responsive design that adapts to various screen sizes, devices,
                and orientations.
              </li>
              <li>
                Clear and consistent navigation patterns across the platform.
              </li>
              <li>
                Regular review and testing of our Service for accessibility
                compliance.
              </li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-4 text-white">
              Known Limitations
            </h2>
            <p>
              While we strive for full accessibility, some content or features
              may not yet be fully accessible. We are actively working to
              identify and resolve any accessibility barriers. As our Service is
              delivered in part through the WhatsApp messaging platform, certain
              accessibility features are subject to WhatsApp's own accessibility
              capabilities and limitations.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-4 text-white">
              Assistive Technology Compatibility
            </h2>
            <p>
              Our website is designed to be compatible with commonly used
              assistive technologies, including screen readers (such as NVDA,
              JAWS, and VoiceOver), voice recognition software, and screen
              magnification tools. We test with these technologies regularly to
              ensure a consistent and accessible experience.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-4 text-white">
              Feedback and Contact
            </h2>
            <p className="mb-4">
              We welcome your feedback on the accessibility of Agent FOMO. If
              you encounter any accessibility barriers, have difficulty
              accessing any part of our Service, or have suggestions for
              improvement, please contact us:
            </p>
            <ul className="list-disc pl-6 space-y-2">
              <li>
                WhatsApp:{" "}
                <a
                  href="https://wa.me/972504244206"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-purple-400 hover:underline"
                >
                  +972-50-424-4206
                </a>
              </li>
            </ul>
            <p className="mt-4">
              We aim to respond to accessibility feedback within 5 business days
              and to resolve reported issues as expediently as possible.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-4 text-white">
              Continuous Improvement
            </h2>
            <p>
              We view accessibility as an ongoing effort and are committed to
              regularly reviewing and updating our practices to align with
              evolving standards and best practices. This statement will be
              updated periodically to reflect our progress and any changes to
              our accessibility status.
            </p>
          </section>

          <div className="pt-8 flex justify-center">
            <a
              href="https://wa.me/972504244206"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center px-6 py-3 rounded-full bg-purple-600 hover:bg-purple-700 text-white font-semibold transition-all hover:scale-105"
            >
              Back to Chat
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
);
